<template>
  <div>
    <h3 :class="[$style.headline]">{{ $t(`usermanagement.form.password_reset_form`) }}</h3>
    <div :class="[$style.updatePasswordContainer]">
      <p>
        {{ $t('usermanagement.password_reset_form_description') }}
      </p>
      <v-btn
        :class="$style.btnToKeyCloak"
        class="btn"
        rounded
        color="primary"
        :elevation="0"
        @click="updatePassword"
        >{{ $t('usermanagement.updatePassword') }}
      </v-btn>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    updatePassword() {
      window.startSSOLoginFlow(true)
    },
  },
}
</script>

<style lang="scss" module>
.headline {
  margin-top: 1.875rem;
  margin-bottom: 0.5rem;
}

.btnToKeyCloak {
  position: relative;

  margin: 2rem 0 0 0;

  letter-spacing: 0.0892857143em;
  text-transform: uppercase;

  transition: all 0.28s cubic-bezier(0.4, 0, 0.2, 1);
}
</style>
